// ** IMPORTANT **: Keep in sync with
// /Users/afikanyati/Documents/2021/Verascope/automations/packages/shared/src/enums/automation-claim-preview-status.enum.ts
export enum SOCIAL_AUTOMATION_CLAIM_PREVIEW_STATUS {
    pending = 'pending',
    eligibleClaims = 'eligible-claims',
    noClaims = 'no-claims',
    verified = 'verified',
    expired = 'expired',
    notFound = 'not-found',
}
